import React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
  Modal,
  Input,
  Button,
  Breadcrumb,
  Spin,
  Table,
  Select,
  message,
  Popover,
  Menu,
} from 'antd';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import intl from 'react-intl-universal';
import privateDrivesIcon from '../../assets/home/open-private-drive.svg';
import privateDrivesIconSMB from '../../assets/home/open-smb.svg';
import privateDrivesIconS3 from '../../assets/home/open-s3.svg';
import privateDrivesIconNFS from '../../assets/home/open-nfs.svg';
import accountIcon from '../../assets/drives/account-icon.svg';
import style from './PrivateDrives.module.scss';
import './PrivateDrives.scss';
import refreshBtnIcon from '../../assets/drives/refresh.svg';
import { fileController } from 'Components/viewer/Controllers/index';

import { store } from 'Store/index';

import DocIcon from '../../assets/drives/document.svg'
import FolderIcon from '../../assets/drives/folder.svg'
import {isMobile} from 'Utils/device';

const { Option } = Select;
const { confirm } = Modal;
const signInPanelWidth = '425px';
const filesListPanelWidth = '565px';
let countClick = 0;
let docName = '';

function isSameStorageFn(selectedStorage, compareStorage) {
  // alias: selectedStorage.alias,
  //   bucket: selectedStorage.bucket,
  //   endpoint: selectedStorage.endpoint,
  //   type: selectedStorage.type,
  if (
    selectedStorage.alias === compareStorage.alias &&
    selectedStorage.endpoint === compareStorage.endpoint &&
    selectedStorage.bucket === compareStorage.bucket &&
    selectedStorage.type === compareStorage.type
  ) {
    return true;
  } else {
    return false;
  }
}

@inject('privateDriveStore')
@observer
class PrivateDrives extends React.Component {
  constructor(props) {
    super(props);

    this.showFolderNum = 4;
    this.tempFolderArr = [];
    this.contentWrapper = React.createRef();
    this.state = {
      sharePath: '',
    };
    this.onConnect = this.onConnect.bind(this);
    this.onCancelModal = this.onCancelModal.bind(this);
    this.createFolderPath = this.createFolderPath.bind(this);
    this.openFolderFromPath = this.openFolderFromPath.bind(this);
    this.createTableColumn = this.createTableColumn.bind(this);
    this.onChangeHost = this.onChangeHost.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.openFolder = this.openFolder.bind(this);
    this.getDriveIntl = this.getDriveIntl.bind(this);
    this.onSaveFile = this.onSaveFile.bind(this);
    this.signOut = this.signOut.bind(this);
    this.isSignIn = this.isSignIn.bind(this);
    this.getSelectedStorageAlias = this.getSelectedStorageAlias.bind(this);
    this.getSelectedStorageIcon = this.getSelectedStorageIcon.bind(this);
    this.getFilesData = this.getFilesData.bind(this);
    this.backToChangeHost = this.backToChangeHost.bind(this);
    this.isShowSignInPanel = this.isShowSignInPanel.bind(this);
    this.isSelectedStorageEmpty = this.isSelectedStorageEmpty.bind(this);
    this.onResume = this.onResume.bind(this);
    this.getSignInInputPanel = this.getSignInInputPanel.bind(this);
    this.doSaveFileShortcut = this.doSaveFileShortcut.bind(this);
    this.getFocusFileName = this.getFocusFileName.bind(this);
    this.clickOrDoubleClick = this.clickOrDoubleClick.bind(this);
    this.doSaveFile = this.doSaveFile.bind(this);
    this.refreshFolder = this.refreshFolder.bind(this);
    this.getAccountNode = this.getAccountNode.bind(this);
    this.handleFolderPathOverLen = this.handleFolderPathOverLen.bind(this);
    this.getAllFolderPath = this.getAllFolderPath.bind(this);
  }

  async componentDidMount() {
    store.privateDriveStore.getStorageList();
    docName = await fileController.getFileName();
  }
  componentDidUpdate() {
    const { showSignInPanel } = this.props.privateDriveStore;

    setTimeout(() => {
      if (isMobile) {
        if (showSignInPanel) {
          document.getElementsByClassName('content-wrapper')[0] && (document.getElementsByClassName('content-wrapper')[0].style.padding = '10px');
          document.getElementsByClassName('ant-modal-content')[0] && (document.getElementsByClassName('ant-modal-content')[0].style.background = 'white');
          document.getElementsByClassName('ant-modal-content')[0] &&
            (document.getElementsByClassName('ant-modal-content')[0].style.height = `${window.innerHeight - 50}px`);
        }
        if (!showSignInPanel) {
          document.getElementsByClassName('content-wrapper')[0] && (document.getElementsByClassName('content-wrapper')[0].style.padding = '10px 0 0 0');
          document.getElementsByClassName('ant-modal-content')[0] && (document.getElementsByClassName('ant-modal-content')[0].style.background = '#D7D8D9');
        }
      }
    });
  }
  getAllFolderPath() {
    if (this.tempFolderArr.length !== 0) {
      // let currentFolderPath;
      let { folderPath, selectedStorage } = this.props.privateDriveStore;

      folderPath.some((item) => {
        let { storage, /* path */ } = item;
        let isSameStorage = isSameStorageFn(selectedStorage, storage);

        if (isSameStorage) {
          // currentFolderPath = path;

          return true;
        }

        return false;
      });

      const currentFolderPathLen = this.state.folderPath.length;

      this.state.folderPath.splice(currentFolderPathLen - 1, 0, ...this.tempFolderArr);
    }
  }
  handleFolderPathOverLen() {
    let currentFolderPath;
    let { folderPath, selectedStorage } = this.props.privateDriveStore;

    folderPath.some((item) => {
      let { storage, path } = item;
      let isSameStorage = isSameStorageFn(selectedStorage, storage);

      if (isSameStorage) {
        currentFolderPath = path;

        return true;
      }

      return false;
    });

    let folderPathLen = currentFolderPath.length;
    let overNum = folderPathLen - this.showFolderNum;
    let folderPathLastIndex = folderPathLen - 1;

    if (folderPathLen > this.showFolderNum) {
      let dropdownFolder;
      let folderArr = [...currentFolderPath];
      const startIndex = folderPathLastIndex - overNum;
      const deleteNum = folderPathLen - this.showFolderNum;

      this.tempFolderArr = folderArr.splice(startIndex, deleteNum);

      dropdownFolder = (
        <React.Fragment>
          <Menu className="drives-folder-path">
            {this.tempFolderArr.map((item, index) => {
              return (
                <Menu.Item key={index}>
                  <span onClick={this.openFolderFromPath.bind(this, item.name, index)}>{item.text}</span>
                </Menu.Item>
              );
            })}
          </Menu>
        </React.Fragment>
      );
      folderArr.forEach((item, index) => {
        const targetIndex = folderArr.length - 2;

        if (index === targetIndex) {
          item.overlay = dropdownFolder;
        } else {
          item.overlay = null;
        }
      });

      this.setState({
        folderPath: folderArr,
      });
    } else {
      let tempArr = [...currentFolderPath];

      tempArr.forEach((item) => {
        item.overlay = false;
      });

      this.setState({
        folderPath: tempArr,
      });

      this.tempFolderArr = [];
    }
  }
  signOut() {
    const { selectedStorage } = this.props.privateDriveStore;

    this.props.privateDriveStore.setAuthenticationParams({ RSAPublicKey: '', username: '', password: '' });
    this.props.privateDriveStore.setIsSignIn({ storage: JSON.parse(JSON.stringify(selectedStorage)), isSignIn: false });
    this.props.privateDriveStore.setShowSignInPanel(true);
    this.props.privateDriveStore.cleanFolderPath();
    this.props.privateDriveStore.setFilesData({ storage: selectedStorage, data: [] });
    this.props.privateDriveStore.setSelectedStorage({});
  }
  onConnectForLD() {}
  onConnect(e) {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      const { selectedStorage } = this.props.privateDriveStore;

      selectedStorage.type === 3 && (err = false);
      if (!err) {
        const msg = intl.formatMessage({ id: 'SelectHostFirst' });

        if (Object.keys(selectedStorage).length === 0 && selectedStorage.constructor === Object) {
          message.warning(msg);
        } else {
          if (selectedStorage.type !== 3) {
            store.privateDriveStore.getRSAPublicKey({ username: values.username.trim(), password: values.password.trim() });
          } else {
            store.privateDriveStore.getRootItems();
          }
        }
      }
    });
  }
  getFilesData() {
    const { selectedStorage, filesData } = this.props.privateDriveStore;
    let result = [];

    filesData.forEach((item) => {
      let { storage, data } = item;
      let isSameStorage = isSameStorageFn(selectedStorage, storage);

      if (isSameStorage) {
        result = data;
      }
    });

    result.forEach((item, index) => {
      item.key = index;
    });

    return toJS(result);
  }
  isSignIn() {
    const { selectedStorage, isSignIn } = this.props.privateDriveStore;
    let result = isSignIn.some((item) => {
      let { storage, isSignIn } = item;

      if (
        storage.alias === selectedStorage.alias &&
        storage.bucket === selectedStorage.bucket &&
        storage.endpoint === selectedStorage.endpoint &&
        storage.type === selectedStorage.type &&
        isSignIn === true
      ) {
        return true;
      }

      return false;
    });

    return result;
  }
  onCancelModal() {
    const uploadFileRequest = store.privateDriveStore.getUploadFileRequest();
    const downloadFileRequest = store.privateDriveStore.getDownloadFileRequest();

    if (uploadFileRequest) {
      const openFilePending = intl.formatMessage({ id: 'OpenFilePending' });
      const abandonOpenFile = intl.formatMessage({ id: 'AbandonOpenFile' });

      confirm({
        title: openFilePending,
        content: abandonOpenFile,
        onOk: () => {
          store.privateDriveStore.cancelUploadFile();
          _handlePrivateDriveStore();
        },
      });
    } else if (downloadFileRequest) {
      const existPendingRequest = intl.formatMessage({ id: 'SaveFilePending' });
      // const abandonRequest = intl.formatMessage({ id: 'AbandonSaveFile' });

      confirm({
        title: existPendingRequest,
        // content: abandonRequest,
        onOk: () => {
          store.privateDriveStore.cancelDownloadFile();
          _handlePrivateDriveStore();
        },
      });
    } else {
      _handlePrivateDriveStore();
    }

    function _handlePrivateDriveStore() {
      store.privateDriveStore.resetNumberOfAjaxCAllPending();
      store.privateDriveStore.setShowDrivesPanel(false);
      store.privateDriveStore.setDriveName('');
    }
  }
  openFolderFromPath(path, index) {
    store.privateDriveStore.openFolderFromPath(path, index);
  }
  createFolderPath() {
    let list = [];
    let { folderPath, selectedStorage } = this.props.privateDriveStore;

    folderPath.forEach((item) => {
      let { storage, path } = item;
      let isSameStorage = isSameStorageFn(selectedStorage, storage);

      if (isSameStorage) {
        list = path.map((item, index) => {
          return (
            <Breadcrumb.Item key={index} overlay={item.overlay}>
              <span onClick={this.openFolderFromPath.bind(this, `${item.name}`, index)}>{item.text}</span>
            </Breadcrumb.Item>
          );
        });
      }
    });

    // list = folderPath[driveName].map((item, index) => {
    //   return (
    //     <Breadcrumb.Item key={index}>
    //       <span onClick={this.openFolderFromPath.bind(this, `${item.name}/`, index)}>{item.text}</span>
    //     </Breadcrumb.Item>
    //   );
    // });

    return list;
  }
  openFolder(driveName, folder) {
    store.privateDriveStore.openFolder(folder);
  }
  downloadFile(driveName, item) {
    store.privateDriveStore.downloadFile({
      item,
      success: ({ blob, filePath }) => {
        this.props.openFileCallback && this.props.openFileCallback({ driveName, blob, filePath, item });
      },
      fail: () => {},
    });
  }
  doSaveFile(filename) {
    store.privateDriveStore.doSaveFile({
      filename: filename || docName,
      success: () => {
        const successMsg = intl.formatMessage({ id: 'UploadingFile.success' });

        this.props.saveSucceedCallback && this.props.saveSucceedCallback();

        store.appStore.setGlobalMessage({ type: 'success', content: successMsg });
        store.privateDriveStore.setShowDrivesPanel(false);
      },
      fail: () => {
        const errorMsg = intl.formatMessage({ id: 'UploadingFile.fail' });

        store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });
      },
    });
  }
  onSaveFile(e) {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { filename } = values;
        const { selectedStorage, filesData } = this.props.privateDriveStore;
        // const saveFile = () => {};

        filesData.forEach((item) => {
          const { storage } = item;
          const isSameStorage = isSameStorageFn(selectedStorage, storage);

          if (isSameStorage) {
            let duplicateFileName = item.data.some((item) => {
              if (filename === item.name) {
                return true;
              }

              return false;
            });

            if (duplicateFileName) {
              const duplicateFileNameTitle = intl.formatMessage({ id: 'Private.duplicateFileNameTitle' });
              const duplicateFileNameContent = intl.formatMessage({ id: 'Private.duplicateFileNameContent' }, { FileName: filename });

              const { confirm } = Modal;

              confirm({
                title: duplicateFileNameTitle,
                content: duplicateFileNameContent,
                onOk: () => {
                  this.doSaveFile(filename);
                },
                onCancel() {},
              });
            } else {
              this.doSaveFile(filename);
            }
          }

          return undefined;
        });

        // function splitFileName(text) {
        //   var pattern = /\.{1}[a-z]{1,}$/;
        //   if (pattern.exec(text) !== null) {
        //     return text.slice(0, pattern.exec(text).index);
        //   } else {
        //     return text;
        //   }
        // }
      }
    });
  }
  createTableColumn() {
    // const { operateType } = this.props.privateDriveStore;
    const name = intl.formatMessage({ id: 'FileName' });
    const size = intl.formatMessage({ id: 'FileSize' });
    const modifyTime = intl.formatMessage({ id: 'ModifyTime' });

    return !isMobile
      ? [
          {
            title: name,
            dataIndex: 'text',
            width: 256,
            ellipsis: true,
            render: (text, record) => {
              return (
                <React.Fragment>
                  {record.isFolder && (
                    <div
                      className="ant-table-row-cell-ellipsis"
                      style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}
                      onDoubleClick={this.openFolder.bind(this, this.props.privateDriveStore.driveName, record)}>
                      {/* <Icon type="folder" style={{fontSize: '19px'}} theme="twoTone" twoToneColor="#E373E7" /> */}
                      <img src={FolderIcon} alt="folder" width="19px" style={{ marginRight: '10px' }} />
                      {text}
                    </div>
                  )}
                  {!record.isFolder && (
                    <div
                      className="ant-table-row-cell-ellipsis"
                      style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}
                      onClick={this.clickOrDoubleClick.bind(this, record)}>
                      {/* <Icon type="file-text" style={{ fontSize: '19px' }} /> */}
                      <img src={DocIcon} alt="document" width="14px" style={{ marginRight: '10px', marginLeft: '2px' }} />
                      {text}
                    </div>
                  )}
                </React.Fragment>
              );
            },
          },
          {
            title: size,
            dataIndex: 'size',
            width: 100,
            ellipsis: true,
          },
          {
            title: modifyTime,
            dataIndex: 'modifiedTime',
            ellipsis: true,
          },
        ]
      : [
          {
            title: name,
            dataIndex: 'name',
            width: 200,
            ellipsis: true,
            render: (text, record) => {
              return (
                <React.Fragment>
                  {record.isFolder && (
                    <div
                      className="ant-table-row-cell-ellipsis file-name-mobile"
                      style={{ wordWrap: 'break-word', wordBreak: 'break-word', display: 'flex' }}
                      onClick={this.openFolder.bind(this, this.props.privateDriveStore.driveName, record)}>
                      <img src={FolderIcon} alt="folder" width="19px" style={{ marginRight: '10px' }} />
                      {/* <Icon type="folder" theme="twoTone" twoToneColor="#E373E7" /> */}
                      {text}
                    </div>
                  )}
                  {!record.isFolder && (
                    <div style={{ wordWrap: 'break-word', wordBreak: 'break-word', display: 'flex' }} onClick={this.clickOrDoubleClick.bind(this, record)}>
                      {/* onClick={this.downloadFile.bind(this, this.props.privateDriveStore.driveName, record)}> */}
                      <img src={DocIcon} alt="document" width="14px" style={{ marginRight: '10px', marginLeft: '2px' }} />
                      <div className="ant-table-row-cell-ellipsis">
                        <div className="file-name-mobile ant-table-row-cell-ellipsis">{text}</div>
                        <div className="font-gray-mobile">{record.modifiedTime}</div>
                      </div>
                      {/* <Icon type="file-text" /> */}
                      {/* {text} */}
                    </div>
                  )}
                </React.Fragment>
              );
            },
          },
          {
            title: size,
            dataIndex: 'size',
            ellipsis: true,
          },
          // {
          //   title: modifyTime,
          //   dataIndex: 'modifiedTime',
          //   ellipsis: true,
          // },
        ];
  }
  clickOrDoubleClick(record) {
    const { operateType } = this.props.privateDriveStore;

    countClick += 1;

    setTimeout(() => {
      if (countClick === 1) {
        operateType === 'save' && this.getFocusFileName(record);
      } else if (countClick === 2) {
        operateType === 'open' && this.downloadFile(this.props.privateDriveStore.driveName, record);
        operateType === 'save' && this.doSaveFileShortcut(record);
      }
      countClick = 0;
    }, 300);
  }
  getFocusFileName(record) {
    const { setFieldsValue } = this.props.form;

    setFieldsValue({
      filename: record.name,
    });
  }
  doSaveFileShortcut(record) {
    const duplicateFileNameTitle = intl.formatMessage({ id: 'Private.duplicateFileNameTitle' });
    const duplicateFileNameContent = intl.formatMessage({ id: 'Private.duplicateFileNameContent' }, { FileName: record.name });

    const { confirm } = Modal;

    confirm({
      title: duplicateFileNameTitle,
      content: duplicateFileNameContent,
      onOk: () => {
        this.doSaveFile(record.name);
      },
      onCancel() {},
    });
  }
  onResume() {
    this.props.privateDriveStore.setShowSignInPanel(false);
  }
  onChangeHost(str) {
    let driveName = '';
    let item = JSON.parse(str);

    switch (item.type) {
      case 1:
        driveName = 'SMB';
        break;
      case 2:
        driveName = 'S3';
        break;
      case 3:
        driveName = 'NFS';
        break;
      default:
        break;
    }

    this.props.privateDriveStore.setDriveName(driveName);
    this.props.privateDriveStore.setSelectedStorage(item);

    const isSignIn = this.isSignIn();

    if (!isSignIn) {
      this.props.privateDriveStore.setShowSignInPanel(true);
    }
  }
  getSaveFileInputPanel() {
    let result = null;
    const save = intl.formatMessage({ id: 'Save' });
    const cancel = intl.formatMessage({ id: 'Cancel' });
    const fileNameRequire = intl.formatMessage({ id: 'PrivateDrive.FileNameRequire' });
    const { getFieldDecorator } = this.props.form;
    const isSignIn = this.isSignIn();
    const { showSignInPanel, operateType } = this.props.privateDriveStore;
    const fileName = intl.formatMessage({ id: 'PrivateDrive.FileName' });
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    };

    if (isSignIn && !showSignInPanel && operateType === 'save') {
      result = (
        <React.Fragment>
          <Form {...formItemLayout} onSubmit={this.onSaveFile} labelAlign="left" className="save-input-panel">
            <Form.Item label={fileName}>
              {getFieldDecorator('filename', {
                initialValue: docName,
                rules: [
                  {
                    required: true,
                    message: fileNameRequire,
                  },
                ],
              })(<Input type="text" />)}
            </Form.Item>
            <Form.Item wrapperCol={{ xs: { span: 24 }, sm: { span: 24 } }} style={{ marginBottom: '0' }}>
              <div style={{ textAlign: 'right' }}>
                <Button size="default" onClick={this.onCancelModal} style={{ marginRight: '10px' }}>
                  {cancel}
                </Button>
                <Button size="default" htmlType="submit">
                  {save}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </React.Fragment>
      );
    }

    return result;
  }
  getSignInInputPanel() {
    const alreadySignIn = intl.formatMessage({ id: 'PrivateDrive.AlreadySignIn' });
    const status = intl.formatMessage({ id: 'PrivateDrive.Status' });
    const userName = intl.formatMessage({ id: 'UserName' });
    const password = intl.formatMessage({ id: 'Password' });
    const userNameRequire = intl.formatMessage({ id: 'PleaseInputYourUserName' });
    const passwordRequire = intl.formatMessage({ id: 'PleaseInputYourPassword' });
    const { getFieldDecorator } = this.props.form;
    const { selectedStorage } = this.props.privateDriveStore;
    const isSignIn = this.isSignIn();
    let result = null;

    if (!isSignIn) {
      selectedStorage.type !== 3
        ? (result = (
            <React.Fragment>
              <Form.Item label={userName}>
                {getFieldDecorator('username', {
                  rules: [
                    {
                      required: true,
                      message: userNameRequire,
                    },
                  ],
                })(<Input type="text" autoComplete="new-password" />)}
              </Form.Item>
              <Form.Item label={password}>
                {getFieldDecorator('password', {
                  rules: [
                    {
                      required: true,
                      message: passwordRequire,
                    },
                  ],
                })(<Input type="password" autoComplete="new-password" />)}
              </Form.Item>
            </React.Fragment>
          ))
        : (result = null);
    } else {
      selectedStorage.type !== 3 &&
        (result = (
          <React.Fragment>
            <Form.Item label={status}>
              <span>{alreadySignIn}</span>
            </Form.Item>
          </React.Fragment>
        ));
    }

    return result;
  }
  getDriveIntl() {
    let intl = {};
    let { selectedStorage } = this.props.privateDriveStore;

    switch (selectedStorage.type) {
      case 1:
        intl.connect = 'ConnectingToSMB';
        intl.storage = 'SMBStorage';
        break;
      case 2:
        intl.connect = 'ConnectingToS3';
        intl.storage = 'S3Storage';
        break;
      case 3:
        intl.connect = 'ConnectingToNFS';
        intl.storage = 'NFSStorage';
        break;
      default:
        intl.connect = 'SelectHost';
        intl.storage = 'NoneStorage';
        break;
    }

    return intl;
  }
  getSelectedStorageAlias() {
    let { selectedStorage } = this.props.privateDriveStore;

    if (selectedStorage.alias) {
      return `(${selectedStorage.alias})`;
    } else {
      return '';
    }
  }
  backToChangeHost() {
    this.props.privateDriveStore.setShowSignInPanel(true);
  }
  getSelectedStorageIcon() {
    let { selectedStorage } = this.props.privateDriveStore;

    if (selectedStorage.type === 1) {
      return (
        <React.Fragment>
          <img src={privateDrivesIconSMB} alt="smb" width="24" height="24" />
        </React.Fragment>
      );
    } else if (selectedStorage.type === 2) {
      return (
        <React.Fragment>
          <img src={privateDrivesIconS3} alt="s3" width="24" height="24" />
        </React.Fragment>
      );
    } else if (selectedStorage.type === 3) {
      return (
        <React.Fragment>
          <img src={privateDrivesIconNFS} alt="ld" width="24" height="24" />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <img src={privateDrivesIcon} alt="privateStorage" width="24" height="24" />
        </React.Fragment>
      );
    }
  }
  isShowSignInPanel() {
    // const isSignIn = this.isSignIn();
    // const { showSignInPanel } = this.props.privateDriveStore;

    // return isSignIn && !showSignInPanel;
    const { showSignInPanel } = this.props.privateDriveStore;

    return showSignInPanel;
  }
  isSelectedStorageEmpty() {
    const { selectedStorage } = this.props.privateDriveStore;

    if (Object.keys(selectedStorage).length === 0 && selectedStorage.constructor === Object) {
      return true;
    } else {
      return false;
    }
  }
  refreshFolder() {
    store.privateDriveStore.refreshFolder();
  }
  getAccountNode() {
    let authenticationParams = this.props.privateDriveStore.getSelectedAuthenticationParams();

    return (
      <React.Fragment>
        <div>
          <img src={accountIcon} alt="account" className="drive-account-avatar" />
          <span>{authenticationParams && authenticationParams.username}</span>
        </div>
      </React.Fragment>
    );
  }
  render() {
    const isSignIn = this.isSignIn();
    const isShowSignInPanel = this.isShowSignInPanel();
    const resume = intl.formatMessage({ id: 'PrivateDrive.Resume' });
    // const changeHost = intl.formatMessage({ id: 'PrivateDrive.ChangHost' });
    const msg = intl.formatMessage({ id: 'SelectHost' });
    const signOut = intl.formatMessage({ id: 'PrivateDrive.signOut' });
    const host = intl.formatMessage({ id: 'Host' });
    const share = intl.formatMessage({ id: 'Share' });

    const cancel = intl.formatMessage({ id: 'Cancel' });
    const connect = intl.formatMessage({ id: 'Connect' });
    // const save = intl.formatMessage({ id: 'Save' });

    const {
      loadingDocBuffer,
      showDrivesPanel,
      driveModalContentHeight,
      storageConfig,
      selectedStorage,
      operateType,
      numberOfAjaxCAllPending,
    } = this.props.privateDriveStore;
    const formItemLayout = {
      labelCol: {
        xs: { span: 5 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 19 },
        sm: { span: 19 },
      },
    };

    let footerNode = null;

    if (!isSignIn && isShowSignInPanel) {
      footerNode = (
        <React.Fragment>
          <Button onClick={this.onCancelModal}>{cancel}</Button>
          <Button onClick={this.onConnect}>{connect}</Button>
        </React.Fragment>
      );
    }
    if (isSignIn && isShowSignInPanel) {
      footerNode = (
        <React.Fragment>
          <Button onClick={this.onCancelModal}>{cancel}</Button>
          <Button onClick={this.onResume}>{resume}</Button>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {!isMobile && (
          <Modal
            className="private-drives-modal for-pc"
            title={isShowSignInPanel ? intl.get('PrivateDrive.Connect') : operateType === 'save' ? intl.get('Save') : intl.get('Open')}
            visible={showDrivesPanel}
            footer={footerNode}
            maskClosable={false}
            centered={true}
            width={isShowSignInPanel ? signInPanelWidth : filesListPanelWidth}
            onCancel={this.onCancelModal}
            destroyOnClose={true}>
            <Spin spinning={numberOfAjaxCAllPending !== 0 || loadingDocBuffer}>
              {/* <div style={{ height: isShowSignInPanel ? '162px' : 'calc(100vh - 300px)' }} className="content-wrapper"> */}
              <div ref={this.contentWrapper} style={{ height: driveModalContentHeight }} className="content-wrapper">
                {isShowSignInPanel && (
                  <React.Fragment>
                    {/* <div style={{ marginBottom: '20px' }}>
                      {this.getSelectedStorageIcon()}
                      <span>{`${intl.get(this.getDriveIntl().connect) + this.getSelectedStorageAlias()}`}</span>
                    </div> */}
                    <Form {...formItemLayout} onSubmit={this.onConnect} labelAlign="left" hideRequiredMark={true}>
                      <Form.Item label={host}>
                        <Select
                          defaultValue={!this.isSelectedStorageEmpty() ? JSON.stringify(selectedStorage) : msg}
                          onChange={this.onChangeHost}
                          dropdownStyle={{ fontSize: '12px' }}>
                          {storageConfig.storage &&
                            storageConfig.storage.length &&
                            storageConfig.storage.map((item, index) => {
                              return (
                                <Option key={index} value={JSON.stringify(item)} className="private-drives-select-option">
                                  {item.type !== 3 && `${item.alias} - ${item.endpoint}`}
                                  {item.type === 3 && `${item.alias}`}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                      <Form.Item label={share}>
                        <span>{selectedStorage.bucket}</span>
                      </Form.Item>
                      {this.getSignInInputPanel()}
                      {/* <Form.Item label={userName}>
                        {getFieldDecorator('username', {
                          rules: [
                            {
                              required: true,
                              message: userNameRequire,
                            },
                          ],
                        })(<Input />)}
                      </Form.Item>
                      <Form.Item label={password}>
                        {getFieldDecorator('password', {
                          rules: [
                            {
                              required: true,
                              message: passwordRequire,
                            },
                          ],
                        })(<Input type="password" />)}
                      </Form.Item> */}
                    </Form>
                  </React.Fragment>
                )}
                {!isShowSignInPanel && (
                  <React.Fragment>
                    {/* <img src={privateDrivesIcon} width="24" height="24" /> */}
                    {/* <span>{intl.get(this.getDriveIntl().storage)}</span> */}
                    {<span style={{ marginRight: '10px', fontSize: '12px' }}>{`${host}: `}</span>}
                    <Select
                      defaultValue={!this.isSelectedStorageEmpty() ? JSON.stringify(selectedStorage) : msg}
                      onChange={this.onChangeHost}
                      style={{ width: '320px' }}>
                      {storageConfig.storage &&
                        storageConfig.storage.length &&
                        storageConfig.storage.map((item, index) => {
                          return (
                            <Option key={index} value={JSON.stringify(item)} className="private-drives-select-option">
                              {item.type !== 3 && `${item.alias} - ${item.endpoint}`}
                              {item.type === 3 && `${item.alias}`}
                            </Option>
                          );
                        })}
                    </Select>
                    {/* <Button size="small" style={{ float: 'right' }} onClick={this.backToChangeHost}>
                      {changeHost}
                    </Button> */}
                    {selectedStorage.type !== 3 && (
                      <Button size="small" className="sign-out-btn" onClick={this.signOut}>
                        {signOut}
                      </Button>
                    )}
                    {/* {operateType === 'save' && (
                      <Button size="small" style={{ float: 'right' }} onClick={this.saveFile}>
                        {save}
                      </Button>
                    )} */}
                    <div className={style['drive-list-wrapper']}>
                      <div className="folder-path-wrapper">
                        <Breadcrumb separator=">">{isSignIn && this.createFolderPath()}</Breadcrumb>
                        <img src={refreshBtnIcon} alt="refresh" onClick={this.refreshFolder} className="refresh-folder-btn" />
                      </div>
                      <div className="files-table-wrapper">
                        <Table
                          columns={this.createTableColumn()}
                          dataSource={this.getFilesData()}
                          pagination={false}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
              <div>{this.getSaveFileInputPanel()}</div>
            </Spin>
          </Modal>
        )}
        {isMobile && (
          <Modal
            className="private-drives-modal"
            title={isShowSignInPanel ? intl.get('PrivateDrive.Connect') : operateType === 'save' ? intl.get('Save') : intl.get('Open')}
            visible={showDrivesPanel}
            footer={footerNode}
            maskClosable={false}
            width={isShowSignInPanel ? signInPanelWidth : filesListPanelWidth}
            onCancel={this.onCancelModal}
            destroyOnClose={true}>
            <Spin spinning={numberOfAjaxCAllPending !== 0 || loadingDocBuffer}>
              {/* <div style={{ height: isShowSignInPanel ? '162px' : 'calc(100vh - 300px)' }} className="content-wrapper"> */}
              <div style={{ height: driveModalContentHeight }} className="content-wrapper">
                {isShowSignInPanel && (
                  <React.Fragment>
                    {/* <div style={{ marginBottom: '20px' }}>
                      {this.getSelectedStorageIcon()}
                      <span>{`${intl.get(this.getDriveIntl().connect) + this.getSelectedStorageAlias()}`}</span>
                    </div> */}
                    <Form {...formItemLayout} onSubmit={this.onConnect} labelAlign="left" hideRequiredMark={true}>
                      <Form.Item label={host}>
                        <Select
                          defaultValue={!this.isSelectedStorageEmpty() ? JSON.stringify(selectedStorage) : msg}
                          onChange={this.onChangeHost}
                          dropdownStyle={{ fontSize: '12px' }}>
                          {storageConfig.storage &&
                            storageConfig.storage.length &&
                            storageConfig.storage.map((item, index) => {
                              return (
                                <Option key={index} value={JSON.stringify(item)} className="private-drives-select-option">
                                  {item.type !== 3 && `${item.alias} - ${item.endpoint}`}
                                  {item.type === 3 && `${item.alias}`}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                      <Form.Item label={share}>
                        <span>{selectedStorage.bucket}</span>
                      </Form.Item>
                      {this.getSignInInputPanel()}
                      {/* <Form.Item label={userName}>
                        {getFieldDecorator('username', {
                          rules: [
                            {
                              required: true,
                              message: userNameRequire,
                            },
                          ],
                        })(<Input />)}
                      </Form.Item>
                      <Form.Item label={password}>
                        {getFieldDecorator('password', {
                          rules: [
                            {
                              required: true,
                              message: passwordRequire,
                            },
                          ],
                        })(<Input type="password" />)}
                      </Form.Item> */}
                    </Form>
                  </React.Fragment>
                )}
                {!isShowSignInPanel && (
                  <React.Fragment>
                    {/* <img src={privateDrivesIcon} width="24" height="24" /> */}
                    {/* <span>{intl.get(this.getDriveIntl().storage)}</span> */}
                    <div style={{ paddingLeft: '15px' }}>
                      {<span style={{ marginRight: '10px', fontSize: '12px' }}>{`${host}: `}</span>}
                      <Select
                        defaultValue={!this.isSelectedStorageEmpty() ? JSON.stringify(selectedStorage) : msg}
                        onChange={this.onChangeHost}
                        style={{ width: '240px' }}>
                        {storageConfig.storage &&
                          storageConfig.storage.length &&
                          storageConfig.storage.map((item, index) => {
                            return (
                              <Option key={index} value={JSON.stringify(item)} className="private-drives-select-option">
                                {item.type !== 3 && `${item.alias} - ${item.endpoint}`}
                                {item.type === 3 && `${item.alias}`}
                              </Option>
                            );
                          })}
                      </Select>
                      {selectedStorage.type !== 3 && (
                        <Popover placement="bottom" title={''} content={this.getAccountNode()} trigger="click" className="drive-account-popover">
                          <img src={accountIcon} alt="account" className="account-btn" />
                        </Popover>
                      )}
                    </div>

                    {/* <Button size="small" style={{ float: 'right' }} onClick={this.backToChangeHost}>
                      {changeHost}
                    </Button> */}
                    {/* {operateType === 'save' && (
                      <Button size="small" style={{ float: 'right' }} onClick={this.saveFile}>
                        {save}
                      </Button>
                    )} */}
                    <div className={style['drive-list-wrapper']}>
                      <div className="folder-path-wrapper">
                        <Breadcrumb separator=">">{isSignIn && this.createFolderPath()}</Breadcrumb>
                      </div>
                      <div className="files-table-wrapper">
                        <Table
                          columns={this.createTableColumn()}
                          dataSource={this.getFilesData()}
                          pagination={false}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>

              {!isShowSignInPanel && operateType === 'open' && (
                <div className="sign-out-btn-wrapper">
                  <Button size="small" className="sign-out-btn" onClick={this.signOut}>
                    {signOut}
                  </Button>
                </div>
              )}
              {/* {!isShowSignInPanel && operateType === 'save' (
                  <Button size="small" className="sign-out-btn" onClick={this.signOut}>
                    {signOut}
                  </Button>
                )} */}
              <div>{this.getSaveFileInputPanel()}</div>
            </Spin>
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

const WrappedPrivateDrives = Form.create({ name: 'register' })(PrivateDrives);

export default WrappedPrivateDrives;
